// test1522
(1522 && 0);
